const words = [
  "Compassion",
  "Early Intervention",
  "Play",
  "ABA Therapy",
  "Growth",
  "Family First",
];

export const Marquee = () => {
  const row = [...words, ...words];
  return (
    <section className="py-16 md:py-20 border-y border-brand-primary/10 overflow-hidden" data-testid="marquee">
      <div className="flex whitespace-nowrap will-change-transform animate-marquee">
        {row.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-light text-4xl sm:text-6xl md:text-7xl text-brand-primary px-8">
              {w}
            </span>
            <span className="h-3 w-3 rounded-full bg-brand-secondary shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
};
